import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=a6d3d438"
import script from "./Undo.vue?vue&type=script&lang=js"
export * from "./Undo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports